import { INSURANCE_PLAN_FAMILY_CROP } from "@datanac/datanac-api-toolkit/dist/datanac-rma-api-helper";
import { useDialog } from "@datanac/datanac-mui-toolkit";
import DeleteForeverOutlined from "@mui/icons-material/DeleteForeverOutlined";
import { IconButton } from "@mui/material";
import { comboTitle } from "api-toolkit/mco/mcoComboTitle";
import { InsuranceIcon } from "components/Icons/Icons";
import { formatPrice } from "utility/formatters";

import { TilleyCard } from "../../Cards/TilleyCard";
import { DeleteIcon } from "../../Icons/Icons";

export default function InsurancePlanCard({ insurancePlan, onChange, onClick }) {
  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();
  const handleDeleteOnClick = () => {
    confirmDialogActions.confirm({
      title: "Delete this entry?",
      prompt: "Are you sure you want to delete this entry?",
      promptDetail: null,
      callback: () => {
        const _newState = { ...insurancePlan };
        _newState.is_active = false;
        onChange && onChange(_newState);
      },
    });
  };

  return (
    <>
      <TilleyCard
        data-testid={`open-insurance-plan-${insurancePlan?.insurance_plan_name}`}
        sx={{ cursor: onClick ? "pointer" : "default" }}
        onClick={onClick}
        Avatar={InsuranceIcon}
        title={
          insurancePlan?.insurance_plan_name +
          // + (insurancePlan?.insurance_option_codes?.includes(INSURANCE_OPTION_CODE_SEED_ENDORSEMENT) ? " (SE)" : "")
          ((insurancePlan?.insurance_plan_family == INSURANCE_PLAN_FAMILY_CROP &&
            " - " + insurancePlan?.unit_structure_code) ||
            "")
        }
        subtitle={
          comboTitle([insurancePlan])
          // formatPercentage(insurancePlan?.coverage_level_percent)
          // + (insurancePlan?.insurance_plan_family == INSURANCE_PLAN_FAMILY_CROP && (" - " + insurancePlan?.unit_structure_code) || "")
        }
        action={
          Boolean(onChange) && (
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteOnClick();
              }}
              data-testid={`delete-insurance-plan-${insurancePlan?.insurance_plan_name}`}
            >
              <DeleteIcon />
            </IconButton>
          )
        }
        details={[
          {
            value: formatPrice(insurancePlan?.producer_premium_amount_per_acre, 2),
            label: "PRODUCER PREMIUM /ac",
          },
          {
            value: formatPrice(insurancePlan?.liability_amount_per_acre, 0),
            label: "COVERAGE /ac",
          },
        ]}
      />
      {confirmDialogComponent}
    </>
  );
}
